import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class WaitSlabModel {
    constructor() {
        const storedData = JSON.parse(localStorage.getItem("waitMinute")) || [];
        this._waitSlabs = storedData;

        if (this._waitSlabs.length === 0) {
            this.initializeFromAPI();
        }
    }

    async initializeFromAPI() {
        try {
            const response = await axios.get(`${API_BASE_URL}waiting-time`);

            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                this._waitSlabs = response.data.data.map(slab => {
                    const waitFrom = slab.WAIT_FROM;
                    const waitTo = slab.WAIT_TO;

                    const waitFromHour = Math.floor(waitFrom / 60);
                    const waitFromMinute = waitFrom % 60;

                    const waitFromFormatted = `${waitFromHour} h ${waitFromMinute} m`;

                    const waitToHour = Math.floor(waitTo / 60);
                    const waitToMinute = waitTo % 60;

                    const waitToFormatted = `${waitToHour} h ${waitToMinute} m`;

                    return {
                        id: slab.PK_SLAB_ID,
                        waitFrom: waitFrom,
                        waitTo: waitTo,
                        chargePerMnt: slab.CHARGE_PER_MNT,
                        waitFromFormatted,
                        waitToFormatted
                    };
                });

                this._waitSlabs.sort((a, b) => a.waitFrom - b.waitFrom);

                this._saveToLocalStorage();
            } else {
                console.warn("No wait slabs found in API response.");
            }
        } catch (error) {
            console.error("Error fetching wait slab data:", error);
        }
    }

    getChargeForWaitTime(waitTime) {
        const slab = this._waitSlabs.find(slab => waitTime >= slab.waitFrom && waitTime <= slab.waitTo);

        if (slab) {
            return slab.chargePerMnt;
        } else {
            return null;
        }
    }
    getAllWaitSlabs() {
        return this._waitSlabs;
    }

    _saveToLocalStorage() {
        localStorage.setItem("waitSlabData", JSON.stringify(this._waitSlabs));
    }
}

export default new WaitSlabModel();